import React, { useState } from 'react'
import ClientRow from './client-row'
import ClientsPagination from './clients-pagination'
import ClientModal from '../client-modal'

const Clients = props => {
  const [newClient, setNewClient] = useState(false)
  const [showPlayer, setShowPlayer] = useState(null)
  const [sortOrder, setSortOrder] = useState('ASC')
  const [sortField, setSortField] = useState(null)
  const [query, setQuery] = useState(null)

  const onUpdate = (player) => {
    player.name = [player.first_name, player.last_name].filter(n => n).join(' ')
    props.onClientUpdate(player)
    setShowPlayer(null)
  }

  const onCreate = (payload) => {
    props.onAddClient(payload)
    setNewClient(false)
  }

  const onSort = (field) => {
    var newSortOrder = sortOrder == 'ASC' ? 'DESC' : 'ASC'
    setSortOrder(newSortOrder)
    setSortField(field)
    props.onSort({ field: field, order: newSortOrder, query: query })
  }

  const handleModalClose = () => {
    setShowPlayer(null)
    setNewClient(false)
  }

  const handleSearch = (event) => {
    setQuery(event.target.value)
    props.onSearch({ field: sortField, order: sortOrder, query: event.target.value })
  }

  const onPageChange = (page) => {
    props.onPageChange({ field: sortField, order: sortOrder, query: query, page: page })
  }

  return (
    <div className='wrapper'>
      <div className='clients-container'>
        <div className='row'>
          <div className='col-lg-2'>
            <a className='btn btn-notice client-add' href='#' onClick={() => setNewClient(true)}>
              <div className='fa fa-plus' /> Add new client
            </a>
          </div>
          <div className='col-lg-offset-6 col-lg-4'>
            <input
              className='form-control'
              placeholder='Search'
              onChange={(e) => {handleSearch(e)}}
            />
          </div>
        </div>
        <div className='row client-portal__table'>
          <div className='col-lg-12 client-portal__container'>
            { props.isLoading && <span className='client-portal__processing'>Processing...</span> }
            <table>
              <thead>
                <tr>
                  <th onClick={() => onSort('name')}>Name</th>
                  <th onClick={() => onSort('phone')}>Phone</th>
                  <th onClick={() => onSort('locations_names')}>Location</th>
                  <th onClick={() => onSort('last_date_played')}>Last time played</th>
                </tr>
              </thead>
              <tbody>
                {props.clients.map((client, index) =>
                  <ClientRow key={index} client={client} onClick={() => setShowPlayer(client.id)}/>
                )}
              </tbody>
            </table>
          </div>
          <div className='col-lg-12'>
            <ClientsPagination
              page={props.page}
              totalCount={props.totalCount}
              onPageChange={onPageChange}
              perPage={props.perPage} />
          </div>
          <div className='col-lg-12'>
            <a className='btn btn-default' href='/admins/facility_clients.xlsx'>Download Excel</a>
          </div>
        </div>
      </div>
      { (showPlayer || newClient) &&
        <ClientModal
          playerId={showPlayer || null}
          contactsPage={true}
          onClose={() => handleModalClose()}
          onUpdate={onUpdate}
          onCreate={onCreate} /> }
    </div>
  )
}

export default Clients
